export type ConversationMarkdownTimezoneStrategy =
  | 'conversation_tz_or_utc'
  | 'user_local_time';

export interface ConversationMarkdownPolicy {
  includeInternalContent: boolean;
  includeVisibleClientDetails: boolean;
  timezoneStrategy: ConversationMarkdownTimezoneStrategy;
}

export const DEFAULT_CONVERSATION_MARKDOWN_POLICY: ConversationMarkdownPolicy = {
  includeInternalContent: true,
  includeVisibleClientDetails: true,
  timezoneStrategy: 'user_local_time',
};

export const createConversationMarkdownPolicy = (
  overrides?: Partial<ConversationMarkdownPolicy>,
): ConversationMarkdownPolicy => {
  return {
    ...DEFAULT_CONVERSATION_MARKDOWN_POLICY,
    ...overrides,
  };
};

export const canIncludeInternalContent = (policy: ConversationMarkdownPolicy): boolean => {
  return policy.includeInternalContent;
};
